import actionTypes from "../actionTypes";
import * as dodavatelUtils from "../../utils/dodavatel/dodavatelUtils";

export const updateDodavatel = (update) => {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.UPDATE_DODAVATEL,
      update,
    });
  };
};

export const changeDodavatel = (dodavatel) => {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.CHANGE_DODAVATEL,
      data: dodavatel,
    });
  };
};

const getDodavatelRequest = () => ({
  type: actionTypes.GET_DODAVATEL_REQUEST,
});
const getDodavatelSuccess = (res) => ({
  type: actionTypes.GET_DODAVATEL_SUCCESS,
  res,
});
const getDodavatelFailure = (error) => ({
  type: actionTypes.GET_DODAVATEL_FAILURE,
  error,
});
export const getDodavatel = (I_DODAVATEL) => {
  return async (dispatch) => {
    try {
      dispatch(getDodavatelRequest());
      let res = await dodavatelUtils.getDodavatel(I_DODAVATEL);
      dispatch(getDodavatelSuccess(res));
    } catch (error) {
      dispatch(getDodavatelFailure(error));
    }
  };
};

const getDodavatelCurrentUserRequest = () => ({
  type: actionTypes.GET_DODAVATEL_CURRENT_USER_REQUEST,
});
const getDodavatelCurrentUserSuccess = (res) => ({
  type: actionTypes.GET_DODAVATEL_CURRENT_USER_SUCCESS,
  res,
});
const getDodavatelCurrentUserFailure = (error) => ({
  type: actionTypes.GET_DODAVATEL_CURRENT_USER_FAILURE,
  error,
});
export const getDodavatelCurrentUser = () => {
  return async (dispatch) => {
    try {
      dispatch(getDodavatelCurrentUserRequest());
      let res = await dodavatelUtils.getDodavatelCurrentUser();
      dispatch(getDodavatelCurrentUserSuccess(res));
    } catch (error) {
      dispatch(getDodavatelCurrentUserFailure(error));
    }
  };
};

const getListDodavatelRequest = () => ({
  type: actionTypes.GET_LIST_DODAVATEL_REQUEST,
});
const getListDodavatelSuccess = (res) => ({
  type: actionTypes.GET_LIST_DODAVATEL_SUCCESS,
  res,
});
const getListDodavatelFailure = (error) => ({
  type: actionTypes.GET_LIST_DODAVATEL_FAILURE,
  error,
});
export const getListDodavatel = (filter, sort, page) => {
  return async (dispatch) => {
    try {
      dispatch(getListDodavatelRequest());
      let res = await dodavatelUtils.getListDodavatel(filter, sort, page);
      dispatch(getListDodavatelSuccess(res));
    } catch (error) {
      dispatch(getListDodavatelFailure(error));
    }
  };
};
